module.exports = __webpack_public_path__ + "static/media/arugula2.4472c3ff.webp";